<script lang="ts" setup>
import { useSales } from '@/composables/useSales'

import { useCityStore } from '@/store/city/city'

import SalesHeader from '@/components/Sales/SalesHeader.vue'
import SalesList from '@/components/Sales/SalesList.vue'

const { pending, breadcrumbs, sales, headerText, seo } = await useSales(true)

const {
  cityInfo: { domain },
} = useCityStore()
</script>

<template>
  <div class="sale">
    <app-head :title="seo.title" :seo="seo" />

    <the-loader v-if="pending" color="var(--ui-primary)" />

    <the-breadcrumbs :breadcrumbs="breadcrumbs" :domain="domain" />

    <sales-header
      v-if="!pending"
      class="sale__header"
      :text="headerText"
      show-archived
    />

    <sales-list v-if="!pending" :sales="sales" :additional-info="null" />
  </div>
</template>

<style lang="scss" scoped>
.sale {
  padding-top: 40px;

  @include media('<desktop') {
    padding: 20px 48px;
  }

  @include media('<tablet') {
    padding: 20px;
  }
}
</style>
